import { useEffect, useState } from "react";
import { Layout } from "../../../ui/layout";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { AssignmentCreation, AssignmentValidation, GetAssignmentById, resetAssigmentCreationStatus, resetAssignmentCreationRequest, resetAssignmentCreationResponse, resetAssignmentValidationStatus, resetGetAssignmentByIdResponse, setAssContractType, setAssCreationAssignmentDate, setAssCreationAssignmentPlace, setAssCreationDepartureProtocolId, setAssCreationNorm, setAssCreationPersonalManagementId, setAssCreationPmContractId, setAssCreationReference, setAssCreationYear, setAssHeadQuarterId, setAssignmentIdToUpdate } from "../slice";
import '../styles.scss'
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left";
import { ContractType, normativa, OptionType, yearOptions } from "../../../utils";
import Button from "../../../ui/molecules/button";
import Input from "../../../ui/molecules/input/Input";
import { SelectCustom } from "../../../ui/molecules/select";
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch";
import { Calendar } from "../../../ui/molecules/calendar";
import { DocumentIcon } from "../../../ui/icons/documentIcon";
import RadioButtonGroup from "../../../ui/molecules/RadioButtonGroup";
import { GetHeadQuarter } from "../../sot/slice";
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from "../../gestionePersonale/slice";
import { GetByIdAnagraphic, resetGetByIdStatus } from "../../gestionePersonale/boxAnagrafica/slice";
import { GetAllContracts, resetGetAllContractsStatus } from "../../gestionePersonale/boxContratti/slice";
import { format } from "date-fns";

export function AddAssignment() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const personalManagementState = useAppSelector(state => state.personalManagement)
    const pmAnagraficaState = useAppSelector(state => state.PMAnagrafica)
    const pmContractState = useAppSelector(state => state.PMContracts)
    const sotState = useAppSelector(state => state.headQuarter)
    const [placeOptions, setPlaceOptions] = useState<OptionType[]>([])
    const [sotOptions, setSotOptions] = useState<OptionType[]>([])
    const [inspToSearch, setInspToSearch] = useState<string[]>([])
    const [inspectors, setInspectors] = useState<OptionType[]>([])
    const [contracts, setContracts] = useState<OptionType[]>([])
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const [selectedOption, setSelectedOption] = useState<ContractType | null>(null);

    useEffect(() => {
        dispatch(resetAssignmentCreationResponse())
        dispatch(resetAssignmentCreationRequest())
        dispatch(resetGetAssignmentByIdResponse())
    }, [])

    useEffect(() => {
        if (assignmentState.assignmentCreationStatus === 'successfully' &&
            assignmentState.assignmentCreationResponse !== undefined
        ) {
            dispatch(resetAssigmentCreationStatus())
            dispatch(setAssignmentIdToUpdate(assignmentState.assignmentCreationResponse))
            dispatch(GetAssignmentById(assignmentState.assignmentCreationResponse))
            navigate('/modificaIncarico')
        }
    }, [assignmentState.assignmentCreationStatus])

    useEffect(() => {
        dispatch(GetHeadQuarter({
            itemsPerPage: 0,
            page: 0
        }))

        dispatch(GetAllPersonalManagement({
            itemsPerPage: 0,
            page: 0,
            function: 'PERSONALE_ISPETTIVO',
            active: true
        }))
    }, [])

    useEffect(() => {
        if (sotState.responseHeadQuarterStatus === 'successfully' &&
            sotState.responseHeadQuarter !== undefined
        ) {
            const data = sotState.responseHeadQuarter.data.map(hq => {
                return {
                    value: `${hq.city} (${hq.province})`,
                    label: `${hq.city} (${hq.province})`
                } as OptionType
            })

            setPlaceOptions(data)

            const dataSot = sotState.responseHeadQuarter.data.map(hq => {
                return {
                    value: `${hq.id}`,
                    label: `${hq.code}`
                } as OptionType
            })

            setSotOptions(dataSot)
        }
    }, [sotState.responseHeadQuarterStatus])

    useEffect(() => {
        if (personalManagementState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            personalManagementState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            const inspectorsIds = personalManagementState.getAllPersonalManagementResourcesResponse.data.map(pm => String(pm.anagraphicId))
            setInspToSearch(inspectorsIds)
        }
    }, [personalManagementState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (inspToSearch.length > 0) {
            dispatch(GetByIdAnagraphic(inspToSearch[0]))
        }
    }, [inspToSearch])

    useEffect(() => {
        if (pmAnagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            pmAnagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))
            const data = pmAnagraficaState.getByIdAnagraphicRequest
            const currInspectors = [...inspectors]
            currInspectors.push({
                value: data.personalManagementId,
                label: `${data.name} ${data.surname}`
            } as OptionType)

            setInspectors(currInspectors)
            setInspToSearch(inspToSearch.slice(1))
        }
    }, [pmAnagraficaState.GetByIdAnagraphicStatus])

    useEffect(() => {
        if (assignmentState.assignmentCreationRequest.personalManagementId)
            dispatch(GetAllContracts({
                itemsPerPage: 0,
                page: 0,
                personalManagementId: assignmentState.assignmentCreationRequest.personalManagementId
            }))
    }, [assignmentState.assignmentCreationRequest.personalManagementId])

    useEffect(() => {
        if (pmContractState.getAllContractsStatus === 'successfully' &&
            pmContractState.getAllContractsResponse !== undefined
        ) {
            dispatch(resetGetAllContractsStatus())
            const data = pmContractState.getAllContractsResponse.data.map(c => {
                return {
                    value: c.id,
                    label: `${c.contractType}, ${c.starting} - ${c.ending ? c.ending : 'No data fine'}`
                } as OptionType
            })

            setContracts(data)
        }
    }, [pmContractState.getAllContractsStatus])

    useEffect(() => {
        if (assignmentState.assignmentValidationStatus === 'successfully') {
            dispatch(resetAssignmentValidationStatus())
            dispatch(AssignmentCreation(assignmentState.assignmentCreationRequest))
        }
    }, [assignmentState.assignmentValidationStatus])

    useEffect(() => {
        if (assignmentState.assignmentCreationStatus === 'successfully') {
            dispatch(resetAssigmentCreationStatus())
        }
    }, [assignmentState.assignmentCreationStatus])

    const handleOptionChange = (value: ContractType) => {
        setSelectedOption(value);
        if (value === 'STANDARD') {
            dispatch(setAssContractType('STANDARD'))
        }
        else {
            dispatch(setAssContractType('C08'))
        }
    };

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Incarichi', 'Inserimento incarico']}
            noPaddingLat
            headerLabel="Gestione Incarichi"
            headerIcon={
                <button style={{ paddingTop: '12px' }} onClick={() => {
                    navigate('/incarichi')
                }}>
                    <ArrowLeftIcon />
                </button>
            }
        >

            <div className='fieldset-container'>
                <div className='fieldset-header'>
                    <div className='text-left'>
                        <span className='rid-title' style={{ color: '#d9e6e8' }}>Creazione Incarico</span>
                    </div>
                </div>
                <div style={{ padding: '24px' }}>
                    <div className='text-left pb-3' style={{ borderBottom: '1px solid #d9e6e8' }}>
                        <span className='assignment-title-bold' style={{ color: '#314d51' }}>Incarico </span>
                        <span className='assignment-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='assignment-title-bold' style={{ color: '#4D797F' }}> Inserimento</span>
                    </div>
                    <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.3' }}>
                            <div className='text-left assignment-text-bold'>
                                Anno
                            </div>
                            <SelectCustom
                                error={assignmentState.assignmentErrors.year}
                                errorLabel='Anno mancante'
                                placeholder='Seleziona anno...'
                                options={yearOptions}
                                value={assignmentState.assignmentCreationRequest.year}
                                onChange={(value) => dispatch(setAssCreationYear(value))}
                            />
                        </div>
                        <div style={{ flex: '0.3' }}>
                            <div className='text-left assignment-text-bold'>
                                Data Incarico
                            </div>
                            <Calendar
                                selected={assignmentState.assignmentCreationRequest.assignmentDate}
                                onChange={(date) => dispatch(setAssCreationAssignmentDate(format(new Date(date), 'yyyy-MM-dd')))}
                                errorLabel={assignmentState.assignmentErrors.assignmentDate ? 'Data mancante' : undefined}
                            />
                        </div>
                        <div style={{ flex: '0.4' }}>
                            <div className='text-left assignment-text-bold'>
                                Sede Incarico
                            </div>
                            <SelectCustom
                                error={assignmentState.assignmentErrors.headQuarterId}
                                errorLabel='Inserire Sede'
                                placeholder='Seleziona sede'
                                options={sotOptions}
                                value={assignmentState.assignmentCreationRequest.headQuarterId}
                                onChange={(value) => dispatch(setAssHeadQuarterId(value))}
                            />
                        </div>
                    </div>
                    <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-bold'>
                                Luogo di Assegnazione
                            </div>
                            <SelectCustom
                                error={assignmentState.assignmentErrors.assignmentPlace}
                                errorLabel='Luogo mancante'
                                placeholder='Seleziona luogo...'
                                options={placeOptions}
                                value={assignmentState.assignmentCreationRequest.assignmentPlace}
                                onChange={(value) => dispatch(setAssCreationAssignmentPlace(value))}
                            />
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-bold'>
                                Norma di riferimento
                            </div>
                            <SelectCustom
                                error={assignmentState.assignmentErrors.norm}
                                errorLabel='Norma mancante'
                                placeholder='Seleziona norma...'
                                options={normativa}
                                value={assignmentState.assignmentCreationRequest.norm}
                                onChange={(value) => dispatch(setAssCreationNorm(value))}
                            />
                        </div>
                    </div>
                    <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div style={{ flex: '0.5' }}>
                            <ProtocolSearch
                                errorLabel={assignmentState.assignmentErrors.departureProtocolId ? 'Protocollo mancante' : undefined}
                                value={assignmentState.assignmentCreationRequest.departureProtocolId}
                                type='departure'
                                onSelect={(value) => dispatch(setAssCreationDepartureProtocolId(value))}
                            />
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className='text-left assignment-text-bold'>
                                Ispettore
                            </div>
                            <SelectCustom
                                error={assignmentState.assignmentErrors.personalManagementId}
                                errorLabel='Ispettore mancante'
                                placeholder='Seleziona ispettore...'
                                options={inspectors}
                                value={assignmentState.assignmentCreationRequest.personalManagementId}
                                onChange={(value) => dispatch(setAssCreationPersonalManagementId(value))}
                            />
                        </div>
                    </div>
                    <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        <div className='text-left assignment-text-bold'>
                            Tipologia Contratto
                        </div>
                        <div style={{ flex: '0.3', display: 'flex', justifyContent: 'left' }}>
                            <RadioButtonGroup
                                name={'Contratto'}
                                options={Object.values(ContractType)}
                                selectedValue={selectedOption}
                                onChange={handleOptionChange}
                                optionLabels={{
                                    [ContractType.STANDARD]: 'STANDARD',
                                    [ContractType.C08]: 'C08',
                                }}
                            />
                        </div>

                    </div>
                    <div className='pb-5 pt-3' style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                        {
                            selectedOption === ContractType.STANDARD && (
                                <div style={{ flex: '0.5' }}>
                                    <div className='text-left assignment-text-bold'>
                                        Contratto
                                    </div>
                                    <SelectCustom
                                        disabled={assignmentState.assignmentCreationRequest.personalManagementId === undefined}
                                        placeholder='Seleziona contratto...'
                                        options={contracts}
                                        value={assignmentState.assignmentCreationRequest.pmContractId}
                                        onChange={(value) => {
                                            dispatch(setAssCreationPmContractId(value))
                                            dispatch(setAssCreationReference(contracts.filter(c => c.value === value)[0].label.split(',')[0]))
                                        }}
                                    />
                                </div>
                            )
                        }
                    </div>
                    <div className='pb-5 pt-3' style={{ display: 'none', gap: '24px', alignItems: 'center' }}>
                        
                        <div style={{flex: '0.5'}}>
                             <div className='text-left assignment-text-bold'>
                                Riferimento
                            </div>
                            <Input
                                value={assignmentState.assignmentCreationRequest.reference}
                                placeholder='Specifica riferimento...'
                                onChangeText={(text) => dispatch(setAssCreationReference(text))}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                        <Button
                            variant='outline'
                            color='dimgrey'
                            size='md'
                            iconPosition='left'
                            icon={<DocumentIcon />}
                            label='Riferimenti C008'
                            onClick={() => setShowPopup(true)}
                        />

                        <Button
                            variant='solid'
                            color='orange'
                            size='md'
                            iconPosition='off'
                            label='Salva'
                            onClick={() => dispatch(AssignmentValidation(assignmentState.assignmentCreationRequest))}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}